// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DatatmpBindJs from "./Datatmp.bind.js";

var data = DatatmpBindJs.datatmp;

function makeAugId(prim) {
  return DatatmpBindJs.makeAugId(prim);
}

var units = data.units;

var traits = data.traits;

var items = data.items;

var augments = data.augments;

var craftableSpats = [
  "12SugarcraftEmblem",
  "12PyroEmblem",
  "12PortalEmblem",
  "12FaerieEmblem",
  "12FrostEmblem",
  "12WitchcraftEmblem",
  "12EldritchEmblem",
  "12HoneymancyEmblem"
];

export {
  data ,
  makeAugId ,
  units ,
  traits ,
  items ,
  augments ,
  craftableSpats ,
  
}
/* data Not a pure module */
